module.exports = __webpack_public_path__ + "img/teacher1-1.5f12fade.png";